<template>
    <header
        class="flex items-center overflow-hidden rounded-t-md bg-gray-200 p-6 md:px-8"
    >
        <Transition :name="productForm().extraDetailsInfo ? 'fade-left' : 'fade-right'" mode="out-in">
            <div
                v-if="Object.keys(productForm().extraDetailsInfo).length"
                class="flex gap-6"
            >
                <span
                    class="flex cursor-pointer items-center justify-center"
                    @click="productForm().setExtraDetailsInfo({})"
                >
                    <Icon :icon="IconArrowLeft" class="text-xl text-primary" :auto-align="false" />
                </span>
                <ul
                    class="flex items-center gap-2"
                >
                    <li
                        class="w-44 cursor-pointer truncate text-primary"
                        @click="productForm().setExtraDetailsInfo({})"
                    >
                        {{
                            props.title
                        }}
                    </li>
                    <li>
                        <Icon :icon="IconChevronRight" class="mx-2 size-2 text-xs text-gray-700" :auto-align="false" />
                    </li>
                    <li>
                        {{
                            productForm().extraDetailsInfo.title
                        }}
                    </li>
                </ul>
            </div>
            <ProductHeader v-else v-bind="props" heading-type="h1" context="modal" />
        </Transition>
    </header>
</template>

<script setup lang="ts">
    import type { ProductOrderBuddy } from '~/types/orderbuddy-types'
    import IconArrowLeft from '@/assets/icons/arrow-left.svg'
    import IconChevronRight from '@/assets/icons/chevron-right.svg'
    import Icon from '~/components/Icon.vue'
    import ProductHeader from '~/components/Product/ProductHeader.vue'
    import { productForm } from '~/store/productForm'
    const props = defineProps<ProductOrderBuddy>()
</script>
